import { Button } from 'components/common'
import { ChevronIcon } from 'components/icons'
import { MouseEventHandler } from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  handleBack?: MouseEventHandler<HTMLButtonElement>
}

const BackButton = ({ handleBack }: Props) => {
  const navigate = useNavigate()

  const handleDefaultback = () => {
    navigate(-1)
  }

  return (
    <Button
      variant="outline"
      buttonText="back"
      className="mb-4 px-4 font-normal"
      icon={<ChevronIcon />}
      iconClassName="!h-3 !w-3 rotate-90"
      onClick={handleBack ?? handleDefaultback}
    />
  )
}

export default BackButton
